/* Sagas */
import autenticationSagas from './autentication';

const rootSagas = [autenticationSagas];

export default rootSagas;
